import { render, staticRenderFns } from "./InfoBatteryPage.vue?vue&type=template&id=1552ac82&scoped=true&"
import script from "./InfoBatteryPage.vue?vue&type=script&lang=js&"
export * from "./InfoBatteryPage.vue?vue&type=script&lang=js&"
import style0 from "./InfoBatteryPage.vue?vue&type=style&index=0&id=1552ac82&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1552ac82",
  null
  
)

export default component.exports